export const newPoint = {
  " De onde você está trabalhando hoje?": "Where are you working from today?",
  "Casa": "Home",
  "Escritório": "Office",
  "Outro": "Other",
  "Selecione o motivo do ponto por exceção": "Select the reason for the exception time entry",
  "Selecione em que local você está": "Select where you are located",
  "Marcar Ponto": "Clock In/Out",
  "Último ponto": "Last Time Entry",
  "Ponto em processamento": "Time entry in progress",
  "Seu ponto das": "Your time entry from",
  "já foi registrado!": "has already been recorded!",
  "Atualize a página para visualizar o ponto.": "Refresh the page to view the time entry.",
  "Atualizar página": "Refresh Page",
  "Horas trabalhadas": "Hours worked",
  "Seu turno está registrado como ": "Your shift is registered as ",
  "Você não interagiu com essa página por mais de 2 minutos. Clique no botão para atualizar a página.": "You have not interacted with this page for more than 2 minutes. Click the button to refresh the page.",
  "Houve um registro a menos de 5 minutos ": "There was a record less than 5 minutes ago ",
  "Você possui um afastamento hoje:": "You have a leave of absence today:",
  "Tem certeza que deseja marcar seu ponto": "Are you sure you want to record your time entry",
  "Selecione qual ponto você deseja marcar:": "Select which time entry you want to record:",
  "Entrada": "Clock-in",
  "Saída intervalo": "Break start",
  "Volta intervalo": "Break end",
  "Seu último ponto foi uma entrada, tem certeza que deseja marcar novamente?": "Your last time entry was a clock-in, are you sure you want to record it again?",
  "Seu último ponto foi uma saída intevalo, tem certeza que deseja marcar novamente?": "Your last time entry was a break start, are you sure you want to record it again?",
  "Seu último ponto foi uma volta intervalo, tem certeza que deseja marcar novamente?": "Your last time entry was a break end, are you sure you want to record it again?",
  "Seu último ponto foi uma saída, tem certeza que deseja marcar novamente?": "Your last time entry was a clock-out, are you sure you want to record it again?",
  "Cancelar": "Cancel",
  "Confirmar": "Confirm",
  "Selecione o local que você está para marcar seu ponto.": "Select the location you are in to record your time entry.",
  "Selecione o motivo do ponto por exceção para marcar seu ponto.": "Select the reason for the exception time entry to record your time entry.",
  "Aguarde um instante que logo seu ponto será confirmado!": "Wait a moment, your time entry will be confirmed soon!",
  "Usuário rejeitou a solicitação de Geolocalização.": "User rejected the Geolocation request.",
  "Webcam not supported on this browser": "Webcam not supported on this browser",
  "Registro de ponto": "Time Entry Record",
  "Parece que você ficou ausente": "It looks like you were away",
  "Marcar ponto novamente?": "Record time entry again?",
  "Sim, continuar": "Yes, continue",
  "Marcar ponto em afastamento": "Record time entry on leave"
};


// WEBPACK FOOTER //
// ./src/resources/enUS/newPoint.js